import * as api from '../api'
import { setUser } from '@doordash/lib-monitoring'
import { get } from 'lodash'
import { SUBMIT_DASHER_APPLICATION } from '.'
import { NON_MARKET_ERROR } from '../constants'
import * as events from '../events'
import SimpleStore from '../utilities/SimpleStore'
import { getUtmSource } from '../utilities/utmSource'
import { getUrlVars } from '../utilities/window'
import { ApplicantData, ApplicationData } from '../api'

export const submitDasherApplication = (applicationData: ApplicantData) => {
  return async (dispatch, getState) => {
    dispatch({ type: SUBMIT_DASHER_APPLICATION.IN_PROGRESS })

    const { referred_by, source } = getUrlVars()
    const utmSource = getUtmSource()
    const referrerId = getState().referrer.id
    const referralCampaign = getState().referralCampaignId
    const signupCountryShortname = getState().signupCountryShortname

    const requestPayload: ApplicationData = {
      ...applicationData,
      referralDomain: document.referrer || undefined,
      referredBy: referrerId || referred_by,
      source: source || utmSource,
      referralCampaign: referralCampaign || undefined,
      signupCountryShortname: signupCountryShortname || undefined,
    }

    try {
      // HACK: prevent dasher applications from being tied
      // to the currently logged in user when going to the
      // dasher application flow **when you've just signed up**
      //
      // See https://doordash.atlassian.net/browse/DX-2212
      // and https://github.com/doordash/doorstep-django/pull/5652
      SimpleStore.delete('token')
      SimpleStore.delete('ddweb_token')
      const data = await api.submitDasherApplication(requestPayload)
      dispatch({ type: SUBMIT_DASHER_APPLICATION.SUCCESS, payload: data })

      await events.identifyDasher(data)
      setUser({ id: data.uniqueLink })

      dispatch(
        events.trackDasherApplySubmissionSuccess({ ...data, ...requestPayload })
      )
      return data
    } catch (error) {
      if (get(error, 'fieldErrors.zipCode') === NON_MARKET_ERROR) {
        const { submarket } = getState().dasherApplyPageContent
        dispatch(
          events.trackDasherApplyNonMarket({
            submarket: submarket || '',
            zipCode: applicationData.zipCode,
          })
        )
      }

      dispatch(events.trackDasherApplySubmissionFailure)
      if (error.error) {
        dispatch(
          events.trackGESubmissionFailureInvalidZip(applicationData.zipCode)
        )
        if (error.campaign) {
          // todo: rework this to use FSA Actions
          // (need to reshape reducers to match)
          dispatch({
            applicationData,
            type: 'GUARANTEED_EARNINGS_WRONG_ZIP.CAMPAIGN_AVAILABLE',
            campaign: error.campaign,
          })
        } else {
          dispatch({
            applicationData,
            type: 'GUARANTEED_EARNINGS_WRONG_ZIP.CAMPAIGN_NOT_AVAILABLE',
          })
        }
      } else {
        dispatch({ type: SUBMIT_DASHER_APPLICATION.FAIL, payload: error })
      }
      throw error
    }
  }
}
